<template>
<div class="md-layout">
  <label><b>Please drag drone icon to desired location or use address field for
      your plan.</b>
    &nbsp;&nbsp;&nbsp;</label>
  <label>{{ $t("Site Coordinates") }}:&nbsp;</label>
  <label class="md-size-60 text-rose">{{ siteCoordinates }}</label>
  <label>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t("Classification") }}:&nbsp;</label>
  <label class="md-size-15 text-warning" v-if="calculating">{{ $t("calculating") }}...</label>
  <label class="md-size-15" style="color: #fcba03;" v-else-if="air_status &&
    !(
      air_status === 'CONTROLLED' ||
      air_status === 'UNCONTROLLED'
    )">{{ $t(air_status) }}</label>
  <label class="md-size-15" style="color: #D30500;" v-else-if="controlled ||
    air_status === 'CONTROLLED'">{{ $t("CONTROLLED") }}</label>
    <label class="md-size-15" v-else-if="!controlled && air_status === ''">--</label>
  <label class="md-size-15" style="color: #00cc00;" v-else-if="!controlled || air_status === 'UNCONTROLLED'">{{ $t("UNCONTROLLED")
    }}</label>
  <div class="md-size-100" id="surveymap"></div>
  <div>
    <md-progress-spinner v-if="loading" class="custom-page-spinner" md-mode="indeterminate"></md-progress-spinner>
  </div>
</div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapboxAccessToken, AIR_STATUS, USER_TYPE } from "@/const.js";
import { RPA_IMAGE_URL, EventBus, createGeoJSONCircle } from "@/helpers";
import swal from "sweetalert2";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { coordinatesGeocoder } from "@/helpers/utils";
import { mapPopupTpl } from "@/helpers/mapPopupTpl";

export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      map: null,
      radius: 0,

      longitude: -80.5449,
      latitude: 43.4723,
      address: "",

      siteCoordinates: "",
      calculating: false,

      loading: false,
      AIR_STATUS
    };
  },
  computed: {
    ...mapFields("survey", [
      "surveyDraft.operationradius",
      "surveyDraft.radiusunit",
      "surveyDraft.operationaltitude",
      "surveyDraft.controlled",
      "surveyDraft.air_status",
      "isclone"
    ]),
    ...mapFields("auth", ["street", "city", "province", "postalcode", "usertype"]),
    ...mapFields("setting", [
      "airspaceGeoData",
      "airspaceAboveSFCGeoData",
      "aerodromeGeoData",
      "heliportGeoData",
      "showAirspace",
      "showAirspaceAboveSFC",
      "showAerodrome"
    ])
  },
  mounted() {
    this.longitude = this.$store.state.survey.surveyDraft.longitude;
    this.latitude = this.$store.state.survey.surveyDraft.latitude;
    this.address = this.$store.state.survey.surveyDraft.address;
    if (this.address === undefined) {
      this.address = "";
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(pos => {
        if(!this.isclone) {
          this.longitude = pos.coords.longitude;
          this.latitude = pos.coords.latitude;
        }
        
        var formatcoords = require("formatcoords");
        this.siteCoordinates = formatcoords(
          this.latitude,
          this.longitude
        ).format("DDMMssX", { latLonSeparator: ", ", decimalPlaces: 0 });
      });
    }

    EventBus.$on("savedSurveyDraftStepOne", () => {
      if (!this.longitude || !this.latitude) {
        if (this.postalcode) {
          var query = `${this.street},${this.city},${this.province},${this.postalcode}`;
          this.$store.dispatch("survey/getCoordinates", query);
          return;
        } else {
          this.longitude = -80.5449;
          this.latitude = 43.4723;
        }
      } else {
        this.$store.dispatch("setting/getGeoData", {
          lng: this.longitude,
          lat: this.latitude
        });

        this.$store.dispatch("survey/getControlled", {
          lng: this.longitude,
          lat: this.latitude
        });
      }
      var formatcoords = require("formatcoords");
      this.siteCoordinates = formatcoords(
        this.latitude,
        this.longitude
      ).format("DDMMssX", { latLonSeparator: ", ", decimalPlaces: 0 });
      this.loadMap();
    });

    EventBus.$on("getCoordinates", () => {
      this.longitude = this.$store.state.survey.surveyDraft.longitude;
      this.latitude = this.$store.state.survey.surveyDraft.latitude;
      if (this.longitude === undefined || this.latitude === undefined) {
        this.longitude = -80.5449;
        this.latitude = 43.4723;
      } else {
        this.$store.dispatch("setting/getGeoData", {
          lng: this.longitude,
          lat: this.latitude
        });

        this.$store.dispatch("survey/getControlled", {
          lng: this.longitude,
          lat: this.latitude
        });
      }

      var formatcoords = require("formatcoords");
      this.siteCoordinates = formatcoords(
        this.latitude,
        this.longitude
      ).format("DDMMssX", { latLonSeparator: ", ", decimalPlaces: 0 });
      this.loadMap();
    });

    EventBus.$on("setControlled", () => {
      this.calculating = false;
    });

    EventBus.$on("setGeoData", () => {
      const airspaceAboveSFCGeo = this.map.getSource('airspacesAboveSFC');
      airspaceAboveSFCGeo.setData(this.airspaceAboveSFCGeoData);

      const airspaceGeo = this.map.getSource('airspaces');
      airspaceGeo.setData(this.airspaceGeoData);

      const aerodromeGeo = this.map.getSource('aerodromes');
      aerodromeGeo.setData(this.aerodromeGeoData);

      const heliportGeo = this.map.getSource('heliports');
      heliportGeo.setData(this.heliportGeoData);
    });
  },
  beforeDestroy() {
    EventBus.$off("savedSurveyDraftStepOne");
    EventBus.$off("getCoordinates");
    EventBus.$off("setControlled");
    EventBus.$off("setGeoData");
    this.map.remove();
  },
  methods: {
    addSourceAndLayers() {
      if (this.map.getLayer("fills")) {
        this.map.removeLayer("fills");
      }
      if (this.map.getLayer("borders")) {
        this.map.removeLayer("borders");
      }
      if (this.map.getLayer("airspaces_symbol")) {
        this.map.removeLayer("airspaces_symbol");
      }
      if (this.map.getSource("airspaces")) {
        this.map.removeSource("airspaces");
      }

      if (this.map.getLayer("aerodromes_fills")) {
        this.map.removeLayer("aerodromes_fills");
      }
      if (this.map.getLayer("aerodromes_borders")) {
        this.map.removeLayer("aerodromes_borders");
      }
      if (this.map.getSource("aerodromes")) {
        this.map.removeSource("aerodromes");
      }

      if (this.map.getLayer("airspacesAboveSFC_fills")) {
        this.map.removeLayer("airspacesAboveSFC_fills");
      }
      if (this.map.getLayer("airspacesAboveSFC_borders")) {
        this.map.removeLayer("airspacesAboveSFC_borders");
      }
      if (this.map.getSource("airspacesAboveSFC")) {
        this.map.removeSource("airspacesAboveSFC");
      }

      if (this.map.getLayer("heliports_fills")) {
        this.map.removeLayer("heliports_fills");
      }
      if (this.map.getLayer("heliports_borders")) {
        this.map.removeLayer("heliports_borders");
      }
      if (this.map.getSource("heliports")) {
        this.map.removeSource("heliports");
      }

      this.map.addSource("airspacesAboveSFC", {
        type: "geojson",
        data: this.airspaceAboveSFCGeoData
      });
      this.map.addLayer({
        id: "airspacesAboveSFC_fills",
        type: "fill",
        source: "airspacesAboveSFC",
        layout: {},
        paint: {
          "fill-color": [
            "case",
            ["==", "SFC", ["get", "FLOOR"]],
            "#e53935",
            "#039be5"
          ],
          "fill-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            0,
            0.2
          ]
        }
      });

      this.map.addLayer({
        id: "airspacesAboveSFC_borders",
        type: "line",
        source: "airspacesAboveSFC",
        layout: {},
        paint: {
          "line-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            "#FFFFFF",
            ["case", ["==", "SFC", ["get", "FLOOR"]], "#e53935", "#039be5"]
          ],
          "line-width": 2
        }
      });

      this.map.addSource("airspaces", {
        type: "geojson",
        data: this.airspaceGeoData
      });
      this.map.addLayer({
        id: "fills",
        type: "fill",
        source: "airspaces",
        layout: {},
        paint: {
          "fill-color": [
            "case",
            ["==", "SFC", ["get", "FLOOR"]],
            "#e53935",
            "#039be5"
          ],
          "fill-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            0,
            0.2
          ]
        }
      });
      this.map.addLayer({
        id: "borders",
        type: "line",
        source: "airspaces",
        layout: {},
        paint: {
          "line-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            "#FFFFFF",
            ["case", ["==", "SFC", ["get", "FLOOR"]], "#e53935", "#039be5"]
          ],
          "line-width": 2
        }
      });
      this.map.addLayer({
        id: "airspaces_symbol",
        type: "symbol",
        source: "airspaces",
        layout: {
          'symbol-placement': 'line-center',
          'text-field': '{FLOOR} - {CEILING}',
          'text-anchor': 'bottom',
          "text-letter-spacing": 0.3,
          'text-size': 10,
        },
        paint: {
          'text-color': 'white',
        }
      });

      this.map.addSource("aerodromes", {
        type: "geojson",
        data: this.aerodromeGeoData,
        generateId: true
      });
      this.map.addLayer({
        id: "aerodromes_fills",
        type: "fill",
        source: "aerodromes",
        layout: {},
        paint: {
          "fill-color": [
            "match",
            ["get", "OPR_TYPE"],
            "Cert",
            "#e53935",
            "Mil",
            "#e53935",
            "#fdd835"
          ],
          "fill-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            0,
            0.2
          ]
        }
      });
      this.map.addLayer({
        id: "aerodromes_borders",
        type: "line",
        source: "aerodromes",
        layout: {},
        paint: {
          "line-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            "#FFFFFF",
            [
              "match",
              ["get", "OPR_TYPE"],
              "Cert",
              "#e53935",
              "Mil",
              "#e53935",
              "#fdd835"
            ]
          ],
          "line-width": 2
        }
      });

      this.map.addSource("heliports", {
        type: "geojson",
        data: this.heliportGeoData,
        generateId: true //This ensures that all features have unique IDs
      });
      this.map.addLayer({
        id: "heliports_fills",
        type: "fill",
        source: "heliports",
        layout: {},
        paint: {
          "fill-color": [
            "match",
            ["get", "OPR_TYPE"],
            "Cert",
            "#fdd835",
            "Mil",
            "#fdd835",
            "#fdd835"
          ],
          "fill-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            0,
            0.2
          ]
        }
      });
      this.map.addLayer({
        id: "heliports_borders",
        type: "line",
        source: "heliports",
        layout: {},
        paint: {
          "line-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            "#FFFFFF",
            [
              "match",
              ["get", "OPR_TYPE"],
              "Cert",
              "#fdd835",
              "Mil",
              "#fdd835",
              "#fdd835"
            ]
          ],
          "line-width": 2
        }
      });
    },
    layerVisibility() {
      this.map.setLayoutProperty('airspacesAboveSFC_fills', 'visibility', 'none');
      this.map.setLayoutProperty('airspacesAboveSFC_borders', 'visibility', 'none');

      this.map.setLayoutProperty('fills', 'visibility', 'none');
      this.map.setLayoutProperty('borders', 'visibility', 'none');
      this.map.setLayoutProperty('airspaces_symbol', 'visibility', 'none');

      this.map.setLayoutProperty('aerodromes_fills', 'visibility', 'none');
      this.map.setLayoutProperty('aerodromes_borders', 'visibility', 'none');

      this.map.setLayoutProperty('heliports_fills', 'visibility', 'none');
      this.map.setLayoutProperty('heliports_borders', 'visibility', 'none');

      if (this.showAirspaceAboveSFC) {
        this.map.setLayoutProperty('airspacesAboveSFC_fills', 'visibility', 'visible');
        this.map.setLayoutProperty('airspacesAboveSFC_borders', 'visibility', 'visible');
      }
      if (this.showAirspace) {
        this.map.setLayoutProperty('fills', 'visibility', 'visible');
        this.map.setLayoutProperty('borders', 'visibility', 'visible');
        this.map.setLayoutProperty('airspaces_symbol', 'visibility', 'visible');
      }
      if (this.showAerodrome) {
        this.map.setLayoutProperty('aerodromes_fills', 'visibility', 'visible');
        this.map.setLayoutProperty('aerodromes_borders', 'visibility', 'visible');
        if (this.usertype === USER_TYPE.MAAC) {
          this.map.setLayoutProperty('heliports_fills', 'visibility', 'visible');
          this.map.setLayoutProperty('heliports_borders', 'visibility', 'visible');
        }
      }
    },
    loadMap() {
      var self = this;

      this.radius = parseFloat(this.operationradius);
      if (this.radiusunit === "nm") {
        this.radius *= 1852;
      }

      mapboxgl.accessToken = mapboxAccessToken;
      this.map = new mapboxgl.Map({
        container: "surveymap",
        //style: "mapbox://styles/benying/cjx8b3cix1kz91co6bnxcy6o3",
        style: "mapbox://styles/mapbox/satellite-streets-v11",
        center: [this.longitude, this.latitude],
        zoom: 16,
        preserveDrawingBuffer: true
      });

      var geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        localGeocoder: coordinatesGeocoder,
        countries: "ca",
        marker: false,
        mapboxgl: mapboxgl,
        language:
          window.localStorage.getItem("locale") === "fr" ? "fr-CA" : "en-US"
      });
      this.map.addControl(geocoder);
      var rpa = document.createElement("div");
      rpa.className = this.usertype === USER_TYPE.MAAC ? "rpaMarker maac" : 'rpaMarker';
      var marker = new mapboxgl.Marker({
        element: rpa,
        draggable: true
      });

      marker.setLngLat([self.longitude, self.latitude]).addTo(self.map);

      marker.on("dragstart", () => {
        this.calculating = true;
      });

      marker.on("dragend", () => {
        this.calculating = true;
        var lngLat = marker.getLngLat();
        this.map.setCenter(lngLat);
        this.$store.dispatch("setting/getGeoData", {
          lng: lngLat.lng,
          lat: lngLat.lat
        });
        this.$store.dispatch("survey/getControlled", {
          lng: lngLat.lng,
          lat: lngLat.lat
        });
        self.longitude = lngLat.lng;
        self.latitude = lngLat.lat;
      });

      marker.on("drag", () => {
        var lngLat = marker.getLngLat();
        var formatcoords = require("formatcoords");
        this.siteCoordinates = formatcoords(
          lngLat.lat,
          lngLat.lng
        ).format("DDMMssX", { latLonSeparator: ", ", decimalPlaces: 0 });
        this.map
          .getSource("rpas")
          .setData(createGeoJSONCircle(lngLat, this.radius));
      });

      geocoder.on("result", function (e) {
        self.calculating = true;
        self.address = e.result.place_name;
        self.longitude = e.result.center[0];
        self.latitude = e.result.center[1];

        self.$store.dispatch("setting/getGeoData", {
          lng: self.longitude,
          lat: self.latitude
        });

        self.$store.dispatch("survey/getControlled", {
          lng: self.longitude,
          lat: self.latitude
        });

        var formatcoords = require("formatcoords");
        self.siteCoordinates = formatcoords(
          self.latitude,
          self.longitude
        ).format("DDMMssX", { latLonSeparator: ", ", decimalPlaces: 0 });

        marker.setLngLat([self.longitude, self.latitude]);

        self.map
          .getSource("rpas")
          .setData(
            createGeoJSONCircle(
              { lng: self.longitude, lat: self.latitude },
              self.radius
            )
          );
      });

      var hoveredFeatures = [];

      this.map.on("load", function () {
        this.loadImage(RPA_IMAGE_URL, (error, image) => {
          if (error) throw error;
          this.addImage("rpa", image);
        });

        this.addSource("rpas", {
          type: "geojson",
          data: createGeoJSONCircle(
            { lng: self.longitude, lat: self.latitude },
            self.radius
          )
        });
        this.addLayer({
          id: "rpasfills",
          type: "fill",
          source: "rpas",
          layout: {},
          paint: {
            "fill-color": "white",
            "fill-opacity": 0.3
          }
        });

        //this.setFilter("fills", ["in", "CLASS", "C", "D", "E", "F"]);
        //this.setFilter("borders", ["in", "CLASS", "C", "D", "E", "F"]);

        var popup = new mapboxgl.Popup({
          closeButton: false,
          // closeOnClick: false
        });

        self.addSourceAndLayers()

        self.layerVisibility()

        this.on("click", ["fills", "aerodromes_fills", "heliports_fills"], function (e) {
          if (hoveredFeatures.length) {
            hoveredFeatures.forEach(item => {
              this.setFeatureState(
                { source: item.source, id: item.id },
                { hover: false }
              );
            })
            hoveredFeatures = [];

            popup.remove();
          }
          let HTML = ''
          const features = e.features.reduce((acc, currentValue) => {
            const isNameExists = acc.some(item => item.id === currentValue.id);
            if (!isNameExists) {
              acc.push(currentValue);
            }
            return acc;
          }, []);
          hoveredFeatures = features
          features.forEach((item, idx) => {
            HTML += mapPopupTpl(item, self.usertype)
            this.setFeatureState(
              { source: item.source, id: item.id },
              { hover: true }
            );
          })
          HTML = `<div style="max-height: 400px; overflow-y: auto;">${HTML}</div>`
          popup
            .setLngLat(e.lngLat)
            .setHTML(HTML)
            .addTo(this);
        });

        popup.on('close', () => {
          if (hoveredFeatures.length) {
            hoveredFeatures.forEach(item => {
              this.setFeatureState(
                { source: item.source, id: item.id },
                { hover: false }
              );
            })
            hoveredFeatures = [];

            popup.remove();
          }
        });

        this.on("dragend", () => {
          self.$store.dispatch("setting/getGeoData", {
            lng: self.longitude,
            lat: self.latitude
          });
        });

        this.on("drag", () => {
          var center = self.map.getCenter();
          self.longitude = center.lng;
          self.latitude = center.lat;
        });
      });
    },
    async showConfirmation(mapImageData) {
      return swal.fire({
        title: this.$t("Confirmation"),
        html: `
                    <p>${this.$t(
          "This map snapshot will be shown on site survey. Please confirm the location and zoom level."
        )}</p>
                    <img src="${mapImageData}" alt="${this.$t(
          "loading"
        )}..." style="width:95%; margin:10px" />
                    <p>${this.siteCoordinates}</p>
                `,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: this.$t("Yes"),
        cancelButtonText: this.$t("Cancel"),
        buttonsStyling: false
      });
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async validate() {
      this.loading = true;
      window.scrollTo(0, 0);

      this.map.addSource("rpa-source", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [this.longitude, this.latitude]
              }
            }
          ]
        }
      });

      this.map.addLayer({
        id: "rpa",
        type: "symbol",
        source: "rpa-source",
        layout: {
          "icon-image": "rpa",
          "icon-size": 1
        }
      });

      await this.sleep(1500);

      var mapImageData = this.map.getCanvas().toDataURL();

      this.map.removeLayer("rpa");
      this.map.removeSource("rpa-source");

      console.log(mapImageData);
      this.loading = false;

      let res = await this.showConfirmation(mapImageData);
      if (res.value && this.air_status) {
        var map_img =
          this.$store.state.auth.email +
          "-" +
          new Date().toISOString().replace(/:/g, ".") +
          ".png";
        this.$emit(
          "on-validated",
          {
            validated: true,
            controlled: this.controlled,
            air_status: this.air_status,
            longitude: this.longitude,
            latitude: this.latitude,
            address: this.address,
            mapImageData: mapImageData,
            map_img: map_img
          }
        );
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="css">
#surveymap {
  width: 100%;
  height: 540px;
  margin: 10px 0px 0px 0px;
  padding: 0px;
}

.rpaMarker {
  background-image: url("../../../../public/img/rpa.png");
  background-size: cover;
  width: 35px;
  height: 35px;
  cursor: pointer;
  &.maac {
    background-image: url("../../../../public/img/plane_blue.svg");
    
  }
}

#address {
  width: 80%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
</style>
